import React, { FunctionComponent } from 'react';
import styles from './styles.module.scss';

type Props = {
  title: string;
  sortable?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
};

export const TableTitle: FunctionComponent<Props> = ({
  title,
  sortable,
  onClick = () => {},
}) => {
  return (
    <div className={styles.tableTitleContainer}>
      <p>{title}</p>{' '}
      {sortable && (
        <button onClick={onClick} className={styles.sortButton} type="button">
          <div className={styles.sortIconContainer}>
            <div className={styles.topArrow} />
            <div className={styles.bottomArrow} />
          </div>
        </button>
      )}
    </div>
  );
};
